import * as yup from 'yup';
import moment from 'moment';
import { DOB_BE_FORMAT, DOB_FE_FORMAT } from '../../AccountOpening.meta';

export const dobValidation = yup
  .string()
  .nullable()
  .required('Date of birth is required')
  // eslint-disable-next-line func-names
  .test('is-dob-valid', 'Date is not valid', function(value) {
    if (!value) {
      // Let the .required() test handle it
      return true;
    }
    const date = moment(value, DOB_FE_FORMAT, true);
    return date.isValid();
  });

export const dobToForm = (dob: string | null): string => {
  return dob ? moment(dob, DOB_BE_FORMAT).format(DOB_FE_FORMAT) : '';
};

export const dobToDraft = (dob: string): string => {
  return dob ? moment(dob, DOB_FE_FORMAT).format(DOB_BE_FORMAT) : '';
};
